import React from "react";
import styles from "./InfoCard.module.scss";

export const InfoCard = ({ heading, value, variant = "default", centered = true }) => (
  <div className={`${styles.card} ${variant === "emphasis" ? styles.card_emphasis : ""} ${centered ? styles.card_centered : ""}`}>
    <div className={styles.card_heading}>{heading}</div>
    <div className={styles.card_value}>{value}</div>
  </div>
);
